var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sign-list" },
    [
      _c("navTab", {
        attrs: { navTabArrType: "mySignList", navTabVal: _vm.navTabVal },
        on: {
          "update:navTabVal": function($event) {
            _vm.navTabVal = $event
          },
          "update:nav-tab-val": function($event) {
            _vm.navTabVal = $event
          }
        }
      }),
      _vm.navTabVal === "corpMySign"
        ? [
            _c(
              "el-row",
              { staticClass: "row", attrs: { type: "flex" } },
              [
                _c("el-col", { attrs: { span: 6 } }),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择", size: "small" },
                                model: {
                                  value: _vm.selectedParm,
                                  callback: function($$v) {
                                    _vm.selectedParm = $$v
                                  },
                                  expression: "selectedParm"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "文件名称",
                                    value: "contractName"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "签署方",
                                    value: "signatoryFullName"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("el-input", {
                              attrs: { size: "small", placeholder: "查询内容" },
                              model: {
                                value: _vm.selectedParmInfo,
                                callback: function($$v) {
                                  _vm.selectedParmInfo = $$v
                                },
                                expression: "selectedParmInfo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("el-col", { attrs: { span: 4 } }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "white-space": "nowrap"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "140px" },
                          attrs: { placeholder: "请选择", size: "small" },
                          model: {
                            value: _vm.selectedStatus,
                            callback: function($$v) {
                              _vm.selectedStatus = $$v
                            },
                            expression: "selectedStatus"
                          }
                        },
                        _vm._l(_vm.statusEnum, function(item, index) {
                          return _c("el-option", {
                            key: "status" + index,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c(
                  "el-col",
                  { attrs: { span: 5 } },
                  [
                    _c(
                      "el-row",
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "daterange",
                            "value-format": "yyyy-MM-dd",
                            "default-time": ["00:00:00", "23:59:59"],
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            size: "small"
                          },
                          model: {
                            value: _vm.datePikerArr,
                            callback: function($$v) {
                              _vm.datePikerArr = $$v
                            },
                            expression: "datePikerArr"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 3 } },
                  [
                    _c(
                      "el-row",
                      { attrs: { type: "flex" } },
                      [
                        _c(
                          "el-col",
                          { staticClass: "text-right", attrs: { span: 12 } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small" },
                                on: { click: _vm.findScreenSign }
                              },
                              [_vm._v("查询")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { staticClass: "text-right", attrs: { span: 12 } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small" },
                                on: { click: _vm.rest }
                              },
                              [_vm._v("重置")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "table-wrap" },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    key: "signlist-" + _vm.$route.query.signStatus,
                    ref: "dataList",
                    staticClass: "data-list",
                    staticStyle: { "min-height": "54vh" },
                    attrs: {
                      data: _vm.tableList,
                      "tooltip-effect": "dark",
                      "expand-row-keys": _vm.expandKeys,
                      "row-key": function(row) {
                        return row.applyId
                      },
                      "header-cell-style": {
                        background: "#f9f9f9",
                        color: "#333333",
                        fontWeight: "500"
                      }
                    },
                    on: {
                      "selection-change": _vm.handleSelectionChange,
                      "cell-mouse-enter": _vm.cellMouseEnter,
                      "cell-mouse-leave": _vm.cellMouseLeave
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "55" }
                    }),
                    _c("el-table-column", {
                      attrs: { label: "文件名称", "min-width": "300" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                      position: "relative",
                                      "padding-top": "10px"
                                    }
                                  },
                                  [
                                    scope.row.files > 1
                                      ? _c(
                                          "span",
                                          { staticClass: "multiFile" },
                                          [_vm._v("多")]
                                        )
                                      : _vm._e(),
                                    _c("apply-name", {
                                      attrs: {
                                        applyType: "signList",
                                        signInfo: {
                                          status: scope.row.applySignStatus,
                                          signNo: scope.row.signInfoNo,
                                          applyNo: scope.row.applyNo,
                                          name: scope.row.contractName,
                                          row: scope.row,
                                          selfSign: scope.row.selfSign,
                                          insureState: scope.row.insureState,
                                          preservationId:
                                            scope.row.preservationId,
                                          multiFile: scope.row.multiFile
                                        }
                                      },
                                      on: {
                                        handleInsurance: function($event) {
                                          return _vm.handleInsurance({
                                            insureState: scope.row.insureState,
                                            preservationId:
                                              scope.row.preservationId,
                                            signNo: scope.row.signInfoNo
                                          })
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                [17, 20, "17", "20"].includes(
                                  scope.row.applySignDealType
                                )
                                  ? _c(
                                      "p",
                                      { staticClass: "textEllipsis" },
                                      [
                                        _vm._v(
                                          "\n                批量签编号：\n                "
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: scope.row.businessNo
                                                ? scope.row.businessNo
                                                : "",
                                              placement: "bottom-start"
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(scope.row.businessNo)
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "p",
                                  { staticClass: "textEllipsis" },
                                  [
                                    _vm._v(
                                      "\n                发起方：\n                "
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: scope.row.ebqUserName,
                                          placement: "bottom-start"
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.ebqUserName))
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c("p", { staticClass: "textEllipsis" }, [
                                  _vm._v(
                                    "\n                发起时间：" +
                                      _vm._s(
                                        _vm._f("formatDateHM")(
                                          scope.row.applyCreateTime
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                  scope.row.fromDingTalk &&
                                  scope.row.fromDingTalk == 1 &&
                                  !_vm.isInDingTalk
                                    ? _c("img", {
                                        staticStyle: { "margin-left": "10px" },
                                        attrs: {
                                          src: "/images/icon/dingIcon.png",
                                          alt: "钉钉",
                                          width: "20px"
                                        }
                                      })
                                    : _vm._e()
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        956495072
                      )
                    }),
                    _c("el-table-column", {
                      attrs: { label: "签署方", "min-width": "250" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-tooltip",
                                  { attrs: { placement: "bottom-start" } },
                                  [
                                    _vm._l(scope.row.signInfoVOS, function(
                                      item,
                                      inx
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: "qs" + inx,
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            "padding-bottom": "5px"
                                          },
                                          attrs: { slot: "content" },
                                          slot: "content"
                                        },
                                        [
                                          item.orderNum && item.orderNum >= 1
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    display: "block",
                                                    width: "13px",
                                                    height: "13px",
                                                    "border-radius": "50%",
                                                    color: "#ffffff",
                                                    border: "1px solid #ffffff",
                                                    "text-align": "center",
                                                    "line-height": "13px",
                                                    "font-size": "12px"
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.orderNum))]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "#ffffff"
                                                  }
                                                },
                                                [_vm._v("·")]
                                              ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                color: "#ffffff",
                                                "font-size": "12px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    【" +
                                                  _vm._s(
                                                    item.signStatus === 0 ||
                                                      item.signStatus === -1
                                                      ? "未签署"
                                                      : item.signStatus === 1
                                                      ? "已签署"
                                                      : "已拒签"
                                                  ) +
                                                  "】\n                  "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                color: "#ffffff",
                                                "font-size": "12px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(item.signatoryFullName)
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "textEllipsis" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.signInfoVOS[0]
                                                  .signatoryFullName
                                              )
                                            )
                                          ]
                                        ),
                                        scope.row.signInfoVOS.length > 1
                                          ? _c(
                                              "p",
                                              { staticClass: "textEllipsis" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.signInfoVOS[1]
                                                      .signatoryFullName
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        [
                                          scope.row.signInfoVOS.length === 3
                                            ? _c(
                                                "p",
                                                { staticClass: "textEllipsis" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.signInfoVOS[2]
                                                        .signatoryFullName
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          scope.row.signInfoVOS.length > 3
                                            ? _c(
                                                "p",
                                                { staticClass: "textEllipsis" },
                                                [_vm._v("···")]
                                              )
                                            : _vm._e()
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  2
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2877343004
                      )
                    }),
                    _c("el-table-column", {
                      attrs: { label: "状态", width: "100" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.applySignStatus === -1
                                  ? _c("span", { staticClass: "red" }, [
                                      _vm._v("处理中")
                                    ])
                                  : scope.row.applySignStatus === 0
                                  ? [
                                      scope.row.selfSign === 1
                                        ? _c("span", { staticClass: "red" }, [
                                            _vm._v("待我签")
                                          ])
                                        : _c("span", { staticClass: "blue" }, [
                                            _vm._v("待ta签")
                                          ])
                                    ]
                                  : scope.row.applySignStatus === 1
                                  ? _c("span", { staticClass: "green" }, [
                                      _vm._v("已完成")
                                    ])
                                  : scope.row.applySignStatus === 2
                                  ? _c("span", { staticClass: "orange" }, [
                                      _vm._v("已拒签")
                                    ])
                                  : scope.row.applySignStatus === 4
                                  ? _c("span", { staticClass: "orange" }, [
                                      _vm._v("已作废")
                                    ])
                                  : scope.row.applySignStatus === -5
                                  ? _c("span", { staticClass: "grey" }, [
                                      _vm._v("已撤销")
                                    ])
                                  : scope.row.applySignStatus === -6
                                  ? _c("span", { staticClass: "grey" }, [
                                      _vm._v("已过期")
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        135992643
                      )
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "130" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return !(
                                scope.row.applyNo &&
                                scope.row.applyNo.startsWith("APLO")
                              ) && scope.row.applySignStatus !== -1
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "operate-box" },
                                      [
                                        scope.row.applySignStatus !== 1 &&
                                        scope.row.signStatus !== 1
                                          ? _c("apply-handles", {
                                              staticClass: "colum",
                                              attrs: {
                                                rowData: scope.row,
                                                applyType: "signList",
                                                fieldType: "applySignStatus"
                                              },
                                              on: {
                                                handleInsurance: function(
                                                  $event
                                                ) {
                                                  return _vm.handleInsurance({
                                                    insureState:
                                                      scope.row.insureState,
                                                    preservationId:
                                                      scope.row.preservationId,
                                                    signNo: scope.row.signInfoNo
                                                  })
                                                },
                                                setCSDialogData:
                                                  _vm.onSetCSDialogData,
                                                resetList: _vm.getSignLists
                                              }
                                            })
                                          : _vm._e(),
                                        scope.row.applySignStatus === 1 ||
                                        scope.row.signStatus === 1
                                          ? [
                                              _c("existing-evidence", {
                                                attrs: { rowData: scope.row },
                                                on: {
                                                  copyTextToQueryEmit:
                                                    _vm.copyTextToQuery
                                                }
                                              }),
                                              _c(
                                                "el-dropdown",
                                                {
                                                  attrs: { trigger: "click" },
                                                  on: {
                                                    "visible-change": function(
                                                      $event
                                                    ) {
                                                      return _vm.visiChange(
                                                        $event,
                                                        scope.row.applyId
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "com-normal-btn"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      更多操作\n                      "
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "com-normal-btn el-icon--right",
                                                        class:
                                                          _vm.visiDown.status &&
                                                          _vm.visiDown
                                                            .rowApplyId ==
                                                            scope.row.applyId
                                                            ? "el-icon-caret-top"
                                                            : "el-icon-caret-bottom"
                                                      })
                                                    ]
                                                  ),
                                                  _c(
                                                    "el-dropdown-menu",
                                                    {
                                                      staticStyle: {
                                                        "background-color":
                                                          "#f5f6f6"
                                                      },
                                                      attrs: {
                                                        slot: "dropdown"
                                                      },
                                                      slot: "dropdown"
                                                    },
                                                    [
                                                      _c("more-button", {
                                                        attrs: {
                                                          rowData: scope.row,
                                                          Cancancel: _vm.isInDingTalk
                                                            ? false
                                                            : true,
                                                          showcancelBtn: true
                                                        },
                                                        on: {
                                                          btnMethodFn:
                                                            _vm.openLYDialog,
                                                          handleInsurance: function(
                                                            $event
                                                          ) {
                                                            return _vm.handleInsurance(
                                                              {
                                                                insureState:
                                                                  scope.row
                                                                    .insureState,
                                                                preservationId:
                                                                  scope.row
                                                                    .preservationId,
                                                                signNo:
                                                                  scope.row
                                                                    .signInfoNo
                                                              }
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          : _vm._e(),
                                        scope.row.applySignStatus === 4 ||
                                        scope.row.signStatus === 4
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "com-normal-btn",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.toApplyDetail(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("查看作废协议")]
                                            )
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ]
                                : undefined
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _c("no-data", {
                      attrs: { slot: "empty", text: "暂无数据" },
                      slot: "empty"
                    })
                  ],
                  1
                ),
                _vm.batchLength && false
                  ? _c("div", { staticClass: "bulkOperation" }, [
                      _vm._v(
                        "\n          已选" +
                          _vm._s(_vm.batchLength) +
                          "份文件\n          "
                      ),
                      false
                        ? _c(
                            "div",
                            {
                              class: _vm.$route.query.match
                                ? "position1"
                                : "position2"
                            },
                            [
                              _vm.$route.query.directoryId
                                ? [
                                    +_vm.$route.query.signStatus !== 3
                                      ? _c(
                                          "el-tooltip",
                                          { attrs: { effect: "dark" } },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  width: "200px",
                                                  "line-height": "1.5"
                                                },
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  批量签署规则：\n                  "
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "1、当前签署方必须有固定签章位置\n                  "
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "2、当前签署方不需要进行身份认证\n                  "
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "3、当前签署方不包含强制阅读、强制现场\n                  "
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "4、当前签署方不需要支付费用\n                "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { size: "small" },
                                                on: { click: _vm.batchSign }
                                              },
                                              [_vm._v("批量签署")]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    +_vm.$route.query.signStatus !== 2
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { size: "small" },
                                            on: { click: _vm.batchDown }
                                          },
                                          [_vm._v("下载")]
                                        )
                                      : _vm._e()
                                  ]
                                : [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini" },
                                        on: { click: _vm.delSignTabList }
                                      },
                                      [_vm._v("删除")]
                                    ),
                                    +_vm.$route.query.signStatus !== 2
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { size: "mini" },
                                            on: { click: _vm.batchDown }
                                          },
                                          [_vm._v("下载")]
                                        )
                                      : _vm._e(),
                                    +_vm.$route.query.signStatus !== 3
                                      ? _c(
                                          "el-tooltip",
                                          { attrs: { effect: "dark" } },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  width: "200px",
                                                  "line-height": "1.5"
                                                },
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  批量签署规则：\n                  "
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "1、当前签署方必须有固定签章位置\n                  "
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "2、当前签署方不需要进行身份认证\n                  "
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "3、当前签署方不包含强制阅读、强制现场\n                  "
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "4、当前签署方不需要支付费用\n                "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { size: "mini" },
                                                on: { click: _vm.batchSign }
                                              },
                                              [_vm._v("批量签署")]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                            ],
                            2
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ],
              1
            ),
            _c(
              "el-row",
              {
                staticClass: "pageation row",
                style: { marginLeft: _vm.$route.query.match == -1 ? "70px" : 0 }
              },
              [
                _c(
                  "el-col",
                  { attrs: { span: 7 } },
                  [
                    _vm.$route.query.directoryId
                      ? [
                          +_vm.$route.query.signStatus !== 3
                            ? _c(
                                "el-tooltip",
                                { attrs: { effect: "dark" } },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        width: "200px",
                                        "line-height": "1.5"
                                      },
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "\n                批量签署规则：\n                "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "1、当前签署方必须有固定签章位置\n                "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "2、当前签署方不需要进行身份认证\n                "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "3、当前签署方不包含强制阅读、强制现场\n                "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "4、当前签署方不需要支付费用\n              "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small" },
                                      on: { click: _vm.batchSign }
                                    },
                                    [_vm._v("批量签署")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          +_vm.$route.query.signStatus !== 2
                            ? _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: { click: _vm.batchDown }
                                },
                                [_vm._v("下载")]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.emitFn("saveToDir")
                                }
                              }
                            },
                            [_vm._v("归档")]
                          )
                        ]
                      : [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: { click: _vm.delSignTabList }
                            },
                            [_vm._v("删除")]
                          ),
                          +_vm.$route.query.signStatus !== 2
                            ? _c(
                                "el-button",
                                {
                                  attrs: { size: "mini" },
                                  on: { click: _vm.batchDown }
                                },
                                [_vm._v("下载")]
                              )
                            : _vm._e(),
                          +_vm.$route.query.signStatus !== 3
                            ? _c(
                                "el-tooltip",
                                { attrs: { effect: "dark" } },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        width: "200px",
                                        "line-height": "1.5"
                                      },
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "\n                批量签署规则：\n                "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "1、当前签署方必须有固定签章位置\n                "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "2、当前签署方不需要进行身份认证\n                "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "3、当前签署方不包含强制阅读、强制现场\n                "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "4、当前签署方不需要支付费用\n              "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: { click: _vm.batchSign }
                                    },
                                    [_vm._v("批量签署")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.emitFn("saveToDir")
                                }
                              }
                            },
                            [_vm._v("归档")]
                          )
                        ]
                  ],
                  2
                ),
                _c(
                  "el-col",
                  { staticClass: "page-flex-end", attrs: { span: 17 } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        small: "",
                        "current-page": _vm.screenParme.itemPage,
                        "page-sizes": [10, 20, 50, 100],
                        "page-size": _vm.screenParme.pageSize,
                        "pager-count": 5,
                        layout: "sizes, prev, pager, next, total",
                        total: _vm.screenParme.pageTotal
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange
                      }
                    }),
                    _c("el-go", {
                      attrs: {
                        "page-size": _vm.screenParme.pageSize,
                        total: _vm.screenParme.pageTotal
                      },
                      on: { "current-change": _vm.handleCurrentChange }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        : [_c("applyListNew")],
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "insurance-dialog",
          attrs: {
            title: "购买保险",
            visible: _vm.insureProductDialog,
            width: "700px"
          },
          on: {
            "update:visible": function($event) {
              _vm.insureProductDialog = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              staticClass: "insurance-form",
              attrs: {
                data: _vm.insureProduct,
                size: "small",
                "label-width": "120px"
              }
            },
            [
              _c("h1", [_vm._v("合同诉讼险")]),
              _c(
                "el-alert",
                {
                  staticStyle: { margin: "10px 0" },
                  attrs: { closable: false, type: "info" }
                },
                [
                  _c("p", [
                    _c("span", { staticClass: "span-important" }, [
                      _vm._v("重要")
                    ]),
                    _vm._v(
                      "\n            理赔说明：主要用于赔付公证费、鉴定费、仲裁、诉讼费、执行费、送达费等费用，最高可赔付\n            "
                    ),
                    _c("span", { staticClass: "span-important-color" }, [
                      _vm._v("10000元")
                    ]),
                    _vm._v("。\n          ")
                  ])
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "合同名称：" } },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        placement: "bottom-start",
                        disabled: _vm.insureProduct.contractName.length < 26
                      }
                    },
                    [
                      _c("div", {
                        attrs: { slot: "content" },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.transferFormat(
                              _vm.insureProduct.contractName,
                              30
                            )
                          )
                        },
                        slot: "content"
                      }),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("ellipsis")(
                              _vm.insureProduct.contractName,
                              26
                            )
                          )
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "合同编号：" } }, [
                _vm._v(_vm._s(_vm.insureProduct.applyNo))
              ]),
              _c("el-form-item", { attrs: { label: "被保人：" } }, [
                _vm._v(_vm._s(_vm.insureProduct.signatoryFullName))
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "参保年限：" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.insureProduct.insureYear,
                        callback: function($$v) {
                          _vm.$set(_vm.insureProduct, "insureYear", $$v)
                        },
                        expression: "insureProduct.insureYear"
                      }
                    },
                    [
                      _c("el-option", { attrs: { value: 1, label: "1年" } }),
                      _c("el-option", { attrs: { value: 2, label: "2年" } }),
                      _c("el-option", { attrs: { value: 3, label: "3年" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "custom-checkbox",
                      attrs: { checked: true },
                      on: {
                        change: function(checked) {
                          return checked
                            ? (_vm.buyInsuranceDisabled = false)
                            : (_vm.buyInsuranceDisabled = true)
                        }
                      }
                    },
                    [
                      _vm._v("\n            已阅读并同意\n            "),
                      _c(
                        "nuxt-link",
                        {
                          staticClass: "color-primary",
                          attrs: {
                            to: "/insure/userNotes",
                            target: "_blank",
                            name: "userNotesBtn"
                          }
                        },
                        [_vm._v("《投保须知》")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: {
                        disabled: _vm.buyInsuranceDisabled,
                        type: "danger"
                      },
                      on: { click: _vm.toBayInsure }
                    },
                    [_vm._v("购买")]
                  )
                ],
                1
              ),
              _c("p", { staticClass: "text-info" }, [
                _vm._v("\n          注：请在合同签署完成\n          "),
                _c("span", { staticClass: "span-important-color" }, [
                  _vm._v("3天之内")
                ]),
                _vm._v("购买保险，一次最多购买\n          "),
                _c("span", { staticClass: "span-important-color" }, [
                  _vm._v("3年")
                ]),
                _vm._v("的保险。\n        ")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "insurance-info",
          attrs: {
            title: "投保信息",
            visible: _vm.insureDialogVisible,
            width: "550px"
          },
          on: {
            "update:visible": function($event) {
              _vm.insureDialogVisible = $event
            }
          }
        },
        [
          _vm.insureDetail
            ? _c("div", { staticClass: "info-box" }, [
                _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
                  _c("span", { staticClass: "title" }, [_vm._v("保险单号:")]),
                  _c("span", { staticClass: "box" }, [
                    _vm._v(_vm._s(_vm.insureDetail.insuranceNo))
                  ]),
                  _c(
                    "a",
                    {
                      staticClass: "color-success",
                      staticStyle: { color: "#ec1c1c", "margin-left": "30px" },
                      attrs: { href: _vm.insureDetail.url, target: "_blank" }
                    },
                    [_vm._v("查看保单>>")]
                  )
                ]),
                _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
                  _c("span", { staticClass: "title" }, [_vm._v("被保人:")]),
                  _c("span", { staticClass: "box" }, [
                    _vm._v(_vm._s(_vm.insureDetail.recognizeeName))
                  ])
                ]),
                _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
                  _c("span", { staticClass: "title" }, [_vm._v("赔偿限额:")]),
                  _c("span", { staticClass: "box" }, [_vm._v("10000元")])
                ]),
                _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
                  _c("span", { staticClass: "title" }, [_vm._v("保险期限:")]),
                  _c("span", { staticClass: "box" }, [
                    _vm._v(
                      _vm._s(_vm.insureDetail.startTime) +
                        "至" +
                        _vm._s(_vm.insureDetail.endTime)
                    )
                  ])
                ]),
                _c("p", [
                  _c("span", { staticClass: "title" }, [_vm._v("理赔热线:")]),
                  _c(
                    "span",
                    { staticClass: "box" },
                    [
                      _vm._v("\n            95556\n            "),
                      _c(
                        "nuxt-link",
                        {
                          staticClass: "color-success",
                          staticStyle: {
                            color: "#ec1c1c",
                            "margin-left": "30px"
                          },
                          attrs: {
                            to: "/signInfo/insureClaim",
                            target: "_blank"
                          }
                        },
                        [_vm._v("查看理赔指南>>")]
                      )
                    ],
                    1
                  )
                ])
              ])
            : _vm._e()
        ]
      ),
      _c("tag-manage", {
        ref: "tagManage",
        on: { close: _vm.getTagList, refresh: _vm.getSignLists }
      }),
      _vm.cSDialogVisible
        ? _c("certiServiceDialog", {
            attrs: {
              dialogVisible: _vm.cSDialogVisible,
              listType: "userList",
              param: _vm.cSDialogData
            },
            on: { setCSDialogData: _vm.onSetCSDialogData }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "ly-info",
          attrs: {
            title: "履约文件",
            visible: _vm.lYDialogVisible,
            width: "850px"
          },
          on: {
            "update:visible": function($event) {
              _vm.lYDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "ly-mask",
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c("el-tab-pane", { attrs: { label: "上传原文件", name: "1" } }, [
                _c("p", { staticClass: "tips" }, [
                  _vm._v(
                    "支持常见图片、文档、视频、音频、压缩包格式，上传后会保存原文件，单个文件大小不超过30MB"
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "box-wrap" },
                  [
                    _c("div", { staticClass: "temone add" }, [
                      _c("span", { staticClass: "el-icon-plus" }),
                      _c("input", {
                        ref: "referenceUpload",
                        staticClass: "file-ipt",
                        attrs: { type: "file" },
                        on: { change: _vm.handleInputChange }
                      })
                    ]),
                    _vm._l(_vm.lYDialogData, function(item, idx) {
                      return _c("div", { key: idx, staticClass: "temone" }, [
                        _c("div", { staticClass: "t-box" }, [
                          _c("img", {
                            staticClass: "y-img",
                            attrs: { src: "/images/web/file-icon.png" }
                          }),
                          _c("div", { staticClass: "msk" }, [
                            _c("span", { staticClass: "des" }, [
                              _vm._v(
                                "上传人：" +
                                  _vm._s(item.userName) +
                                  " -" +
                                  _vm._s(item.accountName)
                              )
                            ])
                          ])
                        ]),
                        _c("div", { staticClass: "a-btn" }, [
                          _c(
                            "a",
                            {
                              staticClass: "has-hover",
                              attrs: { href: _vm.downloadLYFile(item.file) }
                            },
                            [_vm._v("下载")]
                          ),
                          _vm.isDoc(item)
                            ? _c(
                                "a",
                                {
                                  staticClass: "has-hover",
                                  on: {
                                    click: function($event) {
                                      return _vm.previewDoc(item)
                                    }
                                  }
                                },
                                [_vm._v("预览")]
                              )
                            : _vm._e(),
                          _vm.isVideoOrImg(item)
                            ? _c(
                                "a",
                                {
                                  staticClass: "has-hover",
                                  on: {
                                    click: function($event) {
                                      return _vm.previewVideOrImg(item)
                                    }
                                  }
                                },
                                [_vm._v("预览")]
                              )
                            : _vm._e(),
                          item.canDelete
                            ? _c(
                                "a",
                                {
                                  staticClass: "has-hover",
                                  on: {
                                    click: function($event) {
                                      return _vm.delLYFile(item)
                                    }
                                  }
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                          _c("a", { staticClass: "no-hover" }, [
                            _vm._v(_vm._s(item.fileName))
                          ])
                        ])
                      ])
                    })
                  ],
                  2
                )
              ]),
              _c(
                "el-tab-pane",
                { attrs: { label: "上传文件哈希", name: "2" } },
                [
                  _c("p", { staticClass: "tips" }, [
                    _vm._v(
                      "格式没有限制，仅保存上传文件的特征值（哈希），不对文件本身做保存，单个文件大小不超过500M"
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "box-wrap" },
                    [
                      _c("div", { staticClass: "temone add" }, [
                        _c("span", { staticClass: "el-icon-plus" }),
                        _c("input", {
                          ref: "referenceUpload1",
                          staticClass: "file-ipt",
                          attrs: { type: "file" },
                          on: { change: _vm.handleInputChange }
                        })
                      ]),
                      _vm._l(_vm.lYDialogData, function(item, idx) {
                        return _c("div", { key: idx, staticClass: "temone" }, [
                          _c("div", { staticClass: "t-box" }, [
                            _c("img", {
                              staticClass: "y-img",
                              attrs: { src: "/images/web/hash-icon.png" }
                            }),
                            _c("div", { staticClass: "msk" }, [
                              _c("span", { staticClass: "des" }, [
                                _vm._v(
                                  "上传人：" +
                                    _vm._s(item.userName) +
                                    " -" +
                                    _vm._s(item.accountName)
                                )
                              ]),
                              _c("br"),
                              _c(
                                "span",
                                {
                                  staticClass: "des",
                                  staticStyle: { margin: "0" }
                                },
                                [_vm._v("备案号：" + _vm._s(item.presId))]
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "a-btn" }, [
                            _c(
                              "a",
                              {
                                staticClass: "has-hover",
                                on: {
                                  click: function($event) {
                                    return _vm.validLYFile(item)
                                  }
                                }
                              },
                              [_vm._v("验证")]
                            ),
                            item.canDelete
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "has-hover",
                                    on: {
                                      click: function($event) {
                                        return _vm.delLYFile(item)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                            _c("a", { staticClass: "no-hover" }, [
                              _vm._v(_vm._s(item.fileName))
                            ])
                          ])
                        ])
                      })
                    ],
                    2
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("span", { staticClass: "num" }, [
                _vm._v("\n          文件数：\n          "),
                _c("label", [_vm._v(_vm._s(_vm.lYDialogData.length))]),
                _vm._v("个\n        ")
              ]),
              _c(
                "el-button",
                {
                  staticClass: "cancel-btn",
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function($event) {
                      _vm.lYDialogVisible = false
                    }
                  }
                },
                [_vm._v("关闭")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "系统提示",
            visible: _vm.multiBatchDialogVisible,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.multiBatchDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "batch-tips" }, [
            _c("p", { staticStyle: { padding: "20px" } }, [
              _c("i", {
                staticClass: "el-icon-info",
                staticStyle: { "margin-right": "10px", "font-size": "20px" }
              }),
              _vm._v(
                "\n          确定使用以下印章，对 “" +
                  _vm._s(_vm.batchContractName) +
                  "” 等\n          " +
                  _vm._s(_vm.signInfoIdsLength) +
                  "\n          份文件加盖图形章，请选择：\n        "
              )
            ]),
            _c(
              "div",
              { staticClass: "temone-box" },
              _vm._l(_vm.defaultChapter, function(item, i) {
                return _c("div", { key: i, staticClass: "temone" }, [
                  _c(
                    "div",
                    {
                      staticClass: "t-box",
                      class: {
                        "active-chap":
                          _vm.checkChapter &&
                          _vm.checkChapter.signId === item.signId
                      },
                      on: {
                        click: function($event) {
                          return _vm.checkUseChap(item)
                        }
                      }
                    },
                    [
                      item.hasOwnProperty("signUrl")
                        ? [
                            _c("img", {
                              staticClass: "y-img",
                              attrs: { src: _vm.fileOperShow(item.signUrl) }
                            })
                          ]
                        : [
                            _c("img", {
                              staticClass: "y-img",
                              attrs: {
                                src: "data:image/jpeg;base64," + item.signName
                              }
                            })
                          ]
                    ],
                    2
                  ),
                  _c("p", [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          item.hasOwnProperty("signUrl")
                            ? item.signName + "(ID:" + item.signId + ")"
                            : "系统图形章"
                        ) +
                        "\n            "
                    )
                  ])
                ])
              }),
              0
            )
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { color: "#1b1b1b", background: "#fff" },
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.multiBatchDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.batchSignAll }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _c("ViewFilesToDoc", {
        attrs: {
          visibleShow: _vm.visibleShowEnclosureDoc,
          enclosurePreviewNumItem: _vm.enclosurePreviewNumItem
        },
        on: { setViewFilesToDocDialogData: _vm.onSetViewFilesToDocDialogData }
      }),
      _c("ViewFilesToImg", {
        staticStyle: { "text-align": "center" },
        attrs: {
          visibleShow: _vm.visibleShowEnclosure,
          isRefresh: _vm.isRefresh,
          enclosurePreviewNumItem: _vm.enclosurePreviewNumItem,
          imgList: _vm.getEnclosureImgList
        },
        on: { setViewFilesToImgDialogData: _vm.onSetViewFilesToImgDialogData }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.nodeQueryVisible,
            width: "800px",
            "custom-class": "data-dialog",
            "destroy-on-close": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.nodeQueryVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "node_header",
              attrs: { slot: "title" },
              slot: "title"
            },
            [_vm._v("保全链节点查询")]
          ),
          _c("p", { staticStyle: { padding: "10px" } }, [
            _vm._v("当前合同备案号：" + _vm._s(_vm.vpresId))
          ]),
          _c("node-query", { attrs: { vpresId: _vm.vpresId } })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "modifi-seal",
          attrs: { visible: _vm.visibleSealDialog, width: "340px" },
          on: {
            "update:visible": function($event) {
              _vm.visibleSealDialog = $event
            }
          }
        },
        [
          _vm.handWritingChapterInfo
            ? [
                _c("qrcode-vue", {
                  key: "seal",
                  attrs: {
                    value: _vm.handWritingChapterInfo.url,
                    size: 300,
                    leave: "H"
                  }
                }),
                _c(
                  "p",
                  {
                    staticClass: "text-center",
                    staticStyle: {
                      "font-size": "12px",
                      "margin-bottom": "15px"
                    }
                  },
                  [_vm._v("\n          请使用手机扫码设置签字！\n        ")]
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.addUserLocalSignFn }
                  },
                  [_vm._v("图片上传")]
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm.userLocalAddSign
        ? _c("userLocalSeal", {
            attrs: { newSign: _vm.handWritingChapterInfo },
            on: { signCreated: _vm.signCreated }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a8675254", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8675254","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/signInfo/signList.vue
// module id = Uvwc
// module chunks = 29